import React from 'react';

class ContentSlider extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            items: this.props.items||[]
        };
    }
    
    static defaultProps = {
        carouselId: "sliderContent",
        carouselInterval: 5000,
        carouselButtonClasses: "btn btn-outline-primary btn-sm ml-2",
        heading: "Projects",
        items: [
            {heading:"Brayton Point", content:"The cooling towers will be imploded on April 27th. The surrounding area will be closed to both public and maritime navigation.", icon:"icon-calendar", url:"./"},
            {heading:"Upwork Redesign", content:"Adding a special incentive for writing content and some details", icon:"icon-doc", url:"./"}
        ],
        className: "",
        headerClasses: "",
        contentClasses: "text-left text-truncate py-4",
        headingClasses: "mb-0",
        buttonClasses: "btn btn-primary",
        textDetails: "Details"
    };

    render(){
        var { items } = this.state;
        return (
            <div className={'card shadow-sm rounded-lg ' + this.props.className}>
                <div className={'card-header ' + this.props.headerClasses}>
                    <div className="row align-items-center">
                        <div className="col-sm">
                            <h4 className="font-weight-light mb-0">{ this.props.heading }</h4>
                        </div>
                        <div className="col-sm-auto ml-auto">
                            <button className={this.props.carouselButtonClasses} data-target={'#' + this.props.carouselId} data-slide="prev">
                                <span className="fa fa-chevron-left align-middle icons icon-arrow-left" aria-hidden="true"></span>
                                <span className="sr-only">Previous</span>
                            </button>
                            <button className={this.props.carouselButtonClasses} data-target={'#' + this.props.carouselId} data-slide="next">
                                <span className="fa fa-chevron-right align-middle icons icon-arrow-right" aria-hidden="true"></span>
                                <span className="sr-only">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div id={this.props.carouselId} className="carousel slide my-auto w-100" data-ride="carousel" data-interval={this.props.carouselInterval}>
                    <div className="carousel-inner rounded-lg" role="listbox">
                    {
                        items && items.length > 0 ? items.map((item,key) =>
                        (<div className={(key===0)?'carousel-item active':'carousel-item'} key={key}>
                            <div className="card rounded-lg border-0">
                                <div className="row align-items-center no-gutters">
                                    <div className="col-12">
                                        <div className={'card-body ' + this.props.contentClasses}>
                                            <h3 className={this.props.headingClasses}>
                                                <span className={'display-4 font-weight-light float-right ' + item.icon}></span>
                                                {item.heading}
                                            </h3>
                                            <div className={this.props.contentClasses} dangerouslySetInnerHTML={{ __html: item.content }}></div>
                                            <a className={this.props.buttonClasses} href={item.url}>{this.props.textDetails}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )):''}
                    </div>
                </div>
            </div>
        );
    }
}

export default ContentSlider;